// ------------------------------------
// Constants
// ------------------------------------
import { CURRENT_CHILD_ORGANIZATION_SET } from "@p81-common/shell-core-js";

export { CURRENT_CHILD_ORGANIZATION_SET };

// ------------------------------------
// Actions
// ------------------------------------
export function set(subTenantId) {
  return {
    type: CURRENT_CHILD_ORGANIZATION_SET,
    subTenantId,
  };
}
